import { render, staticRenderFns } from "./FieldType2.vue?vue&type=template&id=e22c97da&scoped=true"
import script from "./FieldType2.vue?vue&type=script&lang=js"
export * from "./FieldType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22c97da",
  null
  
)

export default component.exports